// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JlIiUu59IySH_YlqZwmc{background:rgba(0,0,0,.3);border-radius:4px}.TJ40_WHawJTa0euNqpVA{width:41px;height:21px;line-height:21px;display:flex;justify-content:center;padding-top:7px}.M_WUPd5ogs5yufS98K4T{position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "JlIiUu59IySH_YlqZwmc",
	"childPrivacyIcon": "TJ40_WHawJTa0euNqpVA",
	"iconStyle": "M_WUPd5ogs5yufS98K4T"
};
export default ___CSS_LOADER_EXPORT___;
